import update from 'react-addons-update';
import {
  SIKDAEGROUP_LIST,
  SIKDAEPOLICY_LIST,
  SIKDAEPOLICY_ARRAY,
  STORE_LIST,
  DIVISION_LIST,
  STAFF_DIVISION_LIST,
  PAST_DIVISION_LIST,
  CHANGE_DIVISION,
  REDUX_DATA_SET,
  SIKDAEPOLICY_MOD,
  STAFF_SEL,
  STAFF_DEATIL_SEL,
  CHANGE_EXCEL_DATA,
  EXCEL_DOWNLOAD,
  PRESET_SET,
  STAFF_BARCODE_INFO,
  DORMANT_STAFF,
  DIVISION_ALL
} from 'actions/commons';
import { CAPTAIN_DIVISIONS, CAPTAIN_DIVISIONS_L } from '../actions/captainPayment';

let policyArray = [];
let policyIdxArray = [];

function commons(state = {}, action) {
  const { payload } = action;

  switch (action.type) {
    case `${SIKDAEGROUP_LIST}_FULFILLED`:
      return {
        ...state,
        sikdaeGroup: payload
      };

    case `${SIKDAEGROUP_LIST}_PENDING`:
      return {
        ...state,
        sikdaeGroup: payload
      };

    case `${SIKDAEGROUP_LIST}_REJECTED`:
      return {
        ...state,
        sikdaeGroup: null
      };

    case `${SIKDAEPOLICY_LIST}_FULFILLED`:
      return {
        ...state,
        sikdaePolicy: payload
      };

    case `${SIKDAEPOLICY_LIST}_PENDING`:
      return {
        ...state,
        sikdaePolicy: payload
      };

    case `${SIKDAEPOLICY_LIST}_REJECTED`:
      policyIdxArray = [];
      policyArray = [];
      return {
        ...state,
        sikdaePolicyArray: policyArray,
        policyIdxArray
      };

    case `${SIKDAEPOLICY_ARRAY}_FULFILLED`:
      const { data: groupIdx } = payload.config;

      if (payload && payload.data) {
        const { policy } = payload.data;
        if (policy && Array.isArray(policy)) {
          const tempPolicy = [];
          policy.forEach((item) => {
            tempPolicy.push(item);
            policyIdxArray.push(item.idx);
          });

          const data = {
            key: `group${groupIdx}`,
            policy: tempPolicy
          };
          policyArray = update(policyArray, { $push: [data] });
        }

        if (groupIdx === -1) {
          policyIdxArray = [];
          policyArray = [];
        }
      }
      return {
        ...state,
        sikdaePolicyArray: policyArray,
        policyIdxArray
      };

    case `${SIKDAEPOLICY_ARRAY}_PENDING`:
      return {
        ...state,
        sikdaePolicyArray: payload
      };

    case `${SIKDAEPOLICY_ARRAY}_REJECTED`:
      return {
        ...state,
        sikdaePolicyArray: payload
      };

    case `${STORE_LIST}_FULFILLED`:
      return {
        ...state,
        companyStore: payload
      };

    case `${STORE_LIST}_PENDING`:
      return {
        ...state,
        companyStore: payload
      };

    case `${STORE_LIST}_REJECTED`:
      return {
        ...state,
        companyStore: payload
      };

    case `${DIVISION_LIST}_FULFILLED`:
      return {
        ...state,
        division: payload
      };

    case `${DIVISION_LIST}_PENDING`:
      return {
        ...state,
        division: payload
      };

    // 실패 payload는 에러 객체라 그대로 저장하면 소비처의 .data 접근에서 크래시 — null로 비운다
    case `${DIVISION_LIST}_REJECTED`:
      return {
        ...state,
        division: null
      };
    case `${DIVISION_ALL}_FULFILLED`:
      return {
        ...state,
        divisionALL: payload
      };

    case `${DIVISION_ALL}_PENDING`:
      return {
        ...state,
        divisionALL: payload
      };

    case `${DIVISION_ALL}_REJECTED`:
      return {
        ...state,
        divisionALL: null
      };

    case `${STAFF_DIVISION_LIST}_FULFILLED`:
      return {
        ...state,
        staffDivision: payload
      };

    case `${STAFF_DIVISION_LIST}_PENDING`:
      return {
        ...state,
        staffDivision: payload
      };

    case `${STAFF_DIVISION_LIST}_REJECTED`:
      return {
        ...state,
        staffDivision: null
      };

    case `${PAST_DIVISION_LIST}_FULFILLED`:
      return {
        ...state,
        pastDivision: payload
      };

    case `${STAFF_BARCODE_INFO}_FULFILLED`:
      return {
        ...state,
        staffBarcodeInfo: payload
      };

    case `${STAFF_BARCODE_INFO}_PENDING`:
      return {
        ...state,
        staffBarcodeInfo: payload
      };

    case `${STAFF_BARCODE_INFO}_REJECTED`:
      return {
        ...state,
        staffBarcodeInfo: payload
      };

    case `${PAST_DIVISION_LIST}_PENDING`:
      return {
        ...state,
        pastDivision: payload
      };

    case `${PAST_DIVISION_LIST}_REJECTED`:
      return {
        ...state,
        pastDivision: null
      };

    case `${SIKDAEPOLICY_MOD}_FULFILLED`:
      return {
        ...state,
        policyModResult: payload
      };

    case `${SIKDAEPOLICY_MOD}_PENDING`:
      return {
        ...state,
        policyModResult: payload
      };

    case `${SIKDAEPOLICY_MOD}_REJECTED`:
      return {
        ...state,
        policyModResult: payload
      };

    case CHANGE_DIVISION:
      return {
        ...state,
        depth: payload.depth
      };

    case `${STAFF_SEL}_FULFILLED`:
      return {
        ...state,
        staff: payload
      };

    case `${STAFF_SEL}_PENDING`:
      return {
        ...state,
        staff: payload
      };

    case `${STAFF_SEL}_REJECTED`:
      return {
        ...state,
        staff: null
      };

    case `${STAFF_DEATIL_SEL}_FULFILLED`:
      return {
        ...state,
        staffDetail: payload
      };

    case `${STAFF_DEATIL_SEL}_PENDING`:
      return {
        ...state,
        staffDetail: payload
      };
    case `${STAFF_DEATIL_SEL}_REJECTED`:
      return {
        ...state,
        staffDetail: payload
      };

    case `${DORMANT_STAFF}_FULFILLED`:
      return {
        ...state,
        dormant: payload
      };

    case `${DORMANT_STAFF}_PENDING`:
      return {
        ...state,
        dormant: payload
      };

    case `${DORMANT_STAFF}_REJECTED`:
      return {
        ...state,
        dormant: null
      };

    case REDUX_DATA_SET:
      return {
        ...state,
        [payload.type]: {
          ...state[payload.type],
          [payload.name]: payload.value
        }
      };

    case CHANGE_EXCEL_DATA:
      return {
        ...state,
        excel: payload
      };

    case `${EXCEL_DOWNLOAD}_FULFILLED`:
      return {
        ...state,
        excelDownload: payload
      };

    case `${EXCEL_DOWNLOAD}_PENDING`:
      return {
        ...state,
        excelDownload: payload
      };

    case `${EXCEL_DOWNLOAD}_REJECTED`:
      return {
        ...state,
        excelDownload: payload
      };

    case `${PRESET_SET}_FULFILLED`:
      return {
        ...state,
        presetList: payload
      };

    case `${PRESET_SET}_PENDING`:
      return {
        ...state,
        presetList: payload
      };

    case `${PRESET_SET}_REJECTED`:
      return {
        ...state,
        presetList: payload
      };

    case `${CAPTAIN_DIVISIONS_L}`:
      // 대장마켓플레이스 임시
      return {
        ...state,
        staffDivision: { data: payload }
      };
    case `${CAPTAIN_DIVISIONS}_FULFILLED`:
      // 대장마켓플레이스 임시
      return {
        ...state,
        staffDivision: { data: payload }
      };
    // { data: undefined | 에러 객체 }로 감싸면 truthy라 소비처 가드를 통과해 크래시 — 비운다
    case `${CAPTAIN_DIVISIONS}_PENDING`:
      return {
        ...state,
        staffDivision: null
      };
    case `${CAPTAIN_DIVISIONS}_REJECTED`:
      return {
        ...state,
        staffDivision: null
      };

    default:
      return state;
  }
}

export default commons;
